module.exports = __webpack_public_path__ + "static/img/testimage4.a54185a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/testimage4.jpg
// module id = R7+w
// module chunks = 0